module.exports = __webpack_public_path__ + "assets/img/volleyball.0ded175.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/volleyball.svg
// module id = 218
// module chunks = 11